import { render, staticRenderFns } from "./left_panel_performance_table_wrapper.vue?vue&type=template&id=5430d242"
import script from "./left_panel_performance_table_wrapper.vue?vue&type=script&lang=js"
export * from "./left_panel_performance_table_wrapper.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports